import React from 'react';
import { Grid, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Title extends React.Component {

state = {
  category_names: [],
  load: false,
  message: ''
}

componentDidMount() {
  let context = this;
  var x = [];
  let menu = ['Active', 'Inactive'];
  menu.map((y) => {
    x.push({key: y, text: y, value: y});
  });
  try {
    context.setState({
      category_names: x,
    });
  } catch (e) {}
}

onChange = (type) => (e, {value}) => {
  this.setState({
    [type]: value,
    error: ''
  })
}

cancel() {
  this.props.handleClose();
}

update() {
  let context = this;
  let category_name= this.state.category_name;
  let status = this.state.status;
  let tamil_name = this.state.tamil_name;
  let priority = this.state.priority;
  if (category_name == '' || category_name == null || category_name == undefined) {
    this.setState({
      error: 'Enter the Category name',
    })
    return;
  }
  if (tamil_name == '' || tamil_name == null || tamil_name == undefined) {
    this.setState({
      error: 'Enter the Tamil name',
    })
    return;
  }
  if (status == '' || status == null || status == undefined) {
    this.setState({
      error: 'Enter the status',
    })
    return;
  }

  if (priority == '' || priority == null || priority == undefined) {
    this.setState({
      error: 'Enter the priority',
    })
    return;
  }

  let data1 = { 'category_name': category_name, 'status': status, 'tamil_name': tamil_name, 'priority': priority };
  context.setState({
    load: true,
    message: 'Add Category',
  });
  $.ajax({
    type: 'POST',
    data: data1,
    url: Server() + 'addmenu/categorydetails/add.php',
    success: function(data)
    {
      context.setState({
        load: false,
      });
      if (data == 1) {
        context.props.updateDatas();
      }
    },
    error: function(e)
    {
      alert('Try again!!')
      context.setState({
        load: false
      });
    }
  });
}

status = (f, { value }) => {
  this.setState({ status: value })
}


render() {
  let { load, message, status, category_names } = this.state;
  return (
    <div>
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={8}>
        Category Name<br/>
        <Input fluid focus
          onChange={this.onChange('category_name')}
          placeholder='category Name' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
        Tamil Name<br/>
        <Input fluid focus
          onChange={this.onChange('tamil_name')}
          placeholder='Tamil Name' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
        Status<br/>
        <Dropdown style={{ borderColor: '#5A9CBB' }}
         fluid selection onChange={this.status}
         options={category_names} value={status} />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
        Priority<br/>
        <Input fluid focus
          onChange={this.onChange('priority')}
          placeholder='Priority' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <center style={{color: 'red'}}>{this.state.error}</center>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <Button fluid onClick={this.cancel.bind(this)}>Cancel</Button>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <Button fluid onClick={this.update.bind(this)}>Save</Button>
        </Grid.Column>
      </Grid>
      <Loading load={this.state.load} message={this.state.message} />
    </div>
  );
}
}

export default Title;
